import React, { useEffect, useState } from "react";
import { Card, Col, Row, Select, Tag, Typography, Input, Button } from "antd";

import { EnvironmentOutlined, CalendarOutlined } from "@ant-design/icons";
import { regionList } from './defaultCountry';
import "../../css/availableProducersCardView.css";

const { Title, Text } = Typography;
const { Option } = Select;

const AvailableProducersCardView = () => {
    const [filteredProducers, setFilteredProducers] = useState([]);
    const [selectedCulture, setSelectedCulture] = useState(null);
    const [selectedRegion, setSelectedRegion] = useState(null);
    const [searchKeyword, setSearchKeyword] = useState("");

    // Build flat producer list from regions and provinces
    useEffect(() => {
        const producers = [];

        regionList.forEach((region) => {
            region.provinces.forEach((province) => {
                producers.push({
                    region: region.name,
                    province: province.name,
                    culture: province.educatedP,
                    population: province.totalP,
                    isCity: province.isCity,
                });
            });
        });

        setFilteredProducers(producers);
    }, []);

    const handleFilter = () => {
        let filtered = [...filteredProducers];

        if (selectedCulture) {
            filtered = filtered.filter(p => p.culture.toLowerCase().includes(selectedCulture.toLowerCase()));
        }

        if (selectedRegion) {
            filtered = filtered.filter(p => p.region === selectedRegion);
        }

        if (searchKeyword) {
            filtered = filtered.filter(p =>
                p.province.toLowerCase().includes(searchKeyword.toLowerCase()) ||
                p.culture.toLowerCase().includes(searchKeyword.toLowerCase())
            );
        }

        setFilteredProducers(filtered);
    };

    return (
        <div style={{ padding: "24px 5%", maxWidth: 1200, margin: "0 auto" }}>
            <Title level={3} style={{ textAlign: "center", marginBottom: 32 }}>
                🤝 Producteurs prêts pour des **cultures sous contrat**
            </Title>

            <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
                <Col xs={24} sm={8}>
                    <Select
                        allowClear
                        placeholder="Filtrer par culture"
                        style={{ width: "100%" }}
                        onChange={setSelectedCulture}
                    >
                        {Array.from(new Set(filteredProducers.map(p => p.culture))).map(culture => (
                            <Option key={culture} value={culture}>{culture}</Option>
                        ))}
                    </Select>
                </Col>
                <Col xs={24} sm={8}>
                    <Select
                        allowClear
                        placeholder="Filtrer par région"
                        style={{ width: "100%" }}
                        onChange={setSelectedRegion}
                    >
                        {regionList.map(region => (
                            <Option key={region.name} value={region.name}>{region.name}</Option>
                        ))}
                    </Select>
                </Col>
                <Col xs={24} sm={8}>
                    <Input.Search
                        placeholder="Rechercher un producteur ou culture"
                        onSearch={handleFilter}
                        enterButton
                        allowClear
                        onChange={(e) => setSearchKeyword(e.target.value)}
                    />
                </Col>
            </Row>

            <Row gutter={[16, 16]} justify="center">
                {filteredProducers.map((producer, index) => (
                    <Col key={index} xs={24} sm={12} md={8} lg={6}>
                        <Card
                            title={producer.province}
                            hoverable
                            bordered
                            style={{ textAlign: "center", borderRadius: 12 }}
                        >
                            <Tag color="green"><EnvironmentOutlined /> {producer.culture}</Tag>
                            <Tag icon={<EnvironmentOutlined />} color="blue">
                                {producer.region}
                            </Tag>
                            <Tag icon={<CalendarOutlined />} color="volcano">
                                {producer.isCity ? "Centre Urbain" : "Zone Rurale"}
                            </Tag>

                            <Text type="secondary" style={{ display: "block", margin: "10px 0" }}>
                                Population estimée : <strong>{producer.population}</strong>
                            </Text>

                            <Text style={{ fontSize: 13, color: "#333" }}>
                                🌱 Ce producteur est prêt à s’engager dans une culture contractuelle.<br />
                                👉 Contactez-le pour initier une pré-vente sécurisée.
                            </Text>

                            <Button type="primary" block style={{ marginTop: 16 }}>
                                Contacter ce producteur
                            </Button>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default AvailableProducersCardView;
